import { render } from "./SkillsView.vue?vue&type=template&id=5cb96e7b&scoped=true&ts=true"
import script from "./SkillsView.vue?vue&type=script&lang=ts"
export * from "./SkillsView.vue?vue&type=script&lang=ts"

import "./SkillsView.vue?vue&type=style&index=0&id=5cb96e7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb96e7b"]])

export default __exports__